// Ported from genieos/web/src/utils/datetimeLocal.ts @ 84923d036
/**
 * Symmetric helpers for `<input type="datetime-local">` (Demsv1.0#3797).
 *
 * A datetime-local input carries NO timezone. The string it holds is local
 * wall-clock text, and the browser parses it back as local time. Seeding it from
 * `date.toISOString().slice(0, 16)` therefore writes UTC wall-clock into a field
 * that will be read as local: at Turner (UTC-5) the historian's custom range
 * jumped +5 h on every Apply, and because the inputs were re-seeded from the
 * newly-applied range, each Apply compounded another +5 h. The queries ran
 * against the future, so both high-rate tables reported no data despite having
 * rows.
 *
 * These two functions are the format/parse PAIR, kept together and exported so
 * the symmetry is greppable and testable — the bug was an asymmetry between a
 * formatter in one place and an implicit `new Date(...)` in another. Change one,
 * change the other, and keep datetimeLocal.test.ts green in a non-UTC TZ.
 */

import { format, parse } from 'date-fns';

/** The wire format of an `<input type="datetime-local">` value (minute precision). */
export const DATETIME_LOCAL_FORMAT = "yyyy-MM-dd'T'HH:mm";

/**
 * Render a Date as the LOCAL wall clock an `<input type="datetime-local">`
 * expects. Never use `toISOString()` here: it renders UTC.
 */
export function formatDateTimeLocal(date: Date): string {
  return format(date, DATETIME_LOCAL_FORMAT);
}

/**
 * Parse an `<input type="datetime-local">` value as LOCAL wall clock. Returns an
 * Invalid Date for malformed input, so callers keep using `isNaN(d.getTime())`.
 */
export function parseDateTimeLocal(value: string): Date {
  return parse(value, DATETIME_LOCAL_FORMAT, new Date());
}
